import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function Cancel() {
  useEffect(() => {
    document.documentElement.classList.add("design-a");
  }, []);

  return (
    <div className="design-a min-h-screen flex items-center justify-center px-6 stars-bg">
      <div className="relative bg-[#0a1628] gold-border p-12 max-w-xl w-full text-center">
        <XCircle size={64} className="mx-auto text-[#b22234] mb-4" />
        <h1 className="font-display text-5xl font-black text-white">
          EAGLES WERE RECALLED.
        </h1>
        <p className="mt-4 text-white/70">
          You walked away from glorious destiny. No charge has been made.
          Your dignity, however, remains debatable.
        </p>
        <Link
          data-testid="back-home-cancel"
          to="/"
          className="mt-10 inline-flex items-center gap-2 font-accent text-[14px] tracking-[0.3em] text-[#ffd700] hover:text-white"
        >
          <ArrowLeft size={14} /> Reconsider Your Choices
        </Link>
      </div>
    </div>
  );
}
